import { createContext, useContext } from "react";
import { Flags } from "types/shop";

export const FlagsContext = createContext<Flags>({} as Flags);
export const FlagsProvider = FlagsContext.Provider;

export function useFlagsContext() {
  return useContext(FlagsContext);
}
